module.exports = __webpack_public_path__ + "img/factory.cead16d0.jpg";